import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=cd14d204&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=cd14d204&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd14d204",
  null
  
)

export default component.exports